<template>
  <div class="signup-view">
    <div class="signup-view__container">
      <div class="signup-view__header">
        <h1 class="signup-view__title">Join NovelWriter2</h1>
        <p class="signup-view__subtitle">
          Start your writing journey with AI-powered assistance
        </p>
      </div>

      <SignupForm />
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import SignupForm from '@/components/auth/SignupForm.vue';

const router = useRouter();
const authStore = useAuthStore();

// Redirect if already authenticated
onMounted(() => {
  if (authStore.isAuthenticated) {
    router.replace('/dashboard');
  }
});
</script>

<style scoped>
.signup-view {
  min-height: calc(100vh - 72px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-2xl) var(--space-lg);
  background: var(--color-bg-secondary);
}

.signup-view__container {
  width: 100%;
  max-width: 500px;
}

.signup-view__header {
  text-align: center;
  margin-bottom: var(--space-2xl);
}

.signup-view__title {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin: 0 0 var(--space-sm) 0;
}

.signup-view__subtitle {
  font-size: var(--font-size-base);
  color: var(--color-text-secondary);
  margin: 0;
  line-height: var(--line-height-relaxed);
}

/* Responsive Design */
@media (max-width: 768px) {
  .signup-view {
    padding: var(--space-lg);
    min-height: calc(100vh - 64px);
  }

  .signup-view__title {
    font-size: var(--font-size-2xl);
  }
}
</style>
